/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./key.defs.js";
export { main as default } from "./key.defs.js";
